<nav [tabPanel]="tabPanel" mat-tab-nav-bar>
  <a #rla0="routerLinkActive" [active]="rla0.isActive" mat-tab-link routerLink="generated"
     routerLinkActive="mdc-tab-indicator--active">
      <span class="label" matTooltip="All pending equipment grouped by manufacturer that doesn't yet
        belong to any purchase order.">
        Generated
      </span>
  </a>
  <a #rla1="routerLinkActive" [active]="rla1.isActive" mat-tab-link routerLink="drafts"
     routerLinkActive="mdc-tab-indicator--active">
      <span class="label" matTooltip="All draft Purchase Orders.">
        Drafts
      </span>
  </a>
  <a #rla2="routerLinkActive" [active]="rla2.isActive" mat-tab-link routerLink="execution"
     routerLinkActive="mdc-tab-indicator--active">
      <span class="label" matTooltip="All Purchase Orders that have been ordered.">
        Execution
      </span>
  </a>
  <a #rla3="routerLinkActive" [active]="rla3.isActive" mat-tab-link routerLink="complete"
     routerLinkActive="mdc-tab-indicator--active">
      <span class="label" matTooltip="Archive of past Purchase Orders.">
        Complete
      </span>
  </a>
</nav>

<mat-tab-nav-panel #tabPanel class="grid-container sub-page-container">
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
